import { TableContainer, Table, TableBody, TableRow } from '@material-ui/core';
import React from 'react';
import { MyChartData } from './MyChartData';
import numeral from "numeral";
import { AvatarCombustivel } from '../components/avatarCombustivel';
import { KPIComparativo } from '../pages/dashboard/KPIComparativo';
import { SmallestTableCell } from '../components/TableCell';
export interface MyChartDataTableProps {
  rows: MyChartData[];
  prefix?: string;
  format?: string;
  sufix?: string;
  avatarSize?: "small" | "smallest";
  displayName?: boolean;
  dataCompareValue?: Date;
}

export const MyChartDataTable = (props: MyChartDataTableProps) => {
  const {
    format = ",0.00",
    avatarSize = "smallest",
    prefix = (props.prefix ? (props.prefix + " ") : ""),
    sufix = (props.sufix ? (" " + props.sufix) : ""),
    displayName = true
  } = props;

  return (
    <TableContainer >
      <Table size="small" aria-label="custom pagination table">
        <TableBody>
          {props.rows.map((row) => (
            <TableRow key={row.name}>
              {row.sigla && <SmallestTableCell><AvatarCombustivel combustivelSigla={row.sigla} size={avatarSize} /></SmallestTableCell>}
              {displayName && <SmallestTableCell>
                {row.name}
              </SmallestTableCell>}
              {row.compareValue && <SmallestTableCell align="right">
                <KPIComparativo valorBase={row.value} valor={row.compareValue} data={props.dataCompareValue} />
              </SmallestTableCell>}
              <SmallestTableCell align="right">
                {prefix} {numeral(row.value).format(format) + sufix}
              </SmallestTableCell>
            </TableRow>
          ))}
          {/* {emptyRows > 0 && (
                        <TableRow style={{ height: 53 * emptyRows }}>
                            <TableCell colSpan={6} />
                        </TableRow>
                    )} */}
        </TableBody>

      </Table>
    </TableContainer>
  );

};
